import React, { useState } from 'react';
import { KeyRound, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ChangePasswordAdmin = ({ token, onLogout }) => {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg(null);
    if (next.length < 12) return setMsg({ type: 'error', text: 'Le nouveau mot de passe doit contenir au moins 12 caractères.' });
    if (next !== confirm) return setMsg({ type: 'error', text: 'Les deux mots de passe ne correspondent pas.' });
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ current_password: current, new_password: next }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Erreur lors du changement');
      localStorage.setItem('admin_token', data.token);
      setCurrent(''); setNext(''); setConfirm('');
      setMsg({ type: 'ok', text: 'Mot de passe modifié. Vos autres sessions ont été déconnectées.' });
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  const input = 'w-full bg-[#1a1c1b] border border-[#3f4816] rounded-lg px-4 py-2 text-[#dfddd6] focus:border-[#d9fb06] focus:outline-none';

  return (
    <div className="bg-[#302f2c] border border-[#3f4816] rounded-xl overflow-hidden mb-8" data-testid="change-password-admin">
      <button type="button" onClick={() => setOpen(!open)} className="w-full p-4 flex items-center gap-3 text-left hover:bg-[#3f4816]/20 transition-colors" data-testid="change-password-toggle">
        <KeyRound className="text-[#d9fb06]" size={20} />
        <span className="text-lg font-bold text-[#d9fb06]">Sécurité du compte</span>
        <span className="text-xs text-[#888680] ml-auto">{open ? 'Masquer' : 'Changer le mot de passe'}</span>
      </button>
      {open && (
        <form onSubmit={submit} className="p-4 border-t border-[#3f4816] grid grid-cols-1 md:grid-cols-3 gap-3">
          <input type="password" placeholder="Mot de passe actuel" value={current} onChange={(e) => setCurrent(e.target.value)} className={input} autoComplete="current-password" data-testid="current-password-input" />
          <input type="password" placeholder="Nouveau (12 caractères min.)" value={next} onChange={(e) => setNext(e.target.value)} className={input} autoComplete="new-password" data-testid="new-password-input" />
          <input type="password" placeholder="Confirmer le nouveau" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={input} autoComplete="new-password" data-testid="confirm-password-input" />
          {msg && (
            <p className={`md:col-span-3 text-sm ${msg.type === 'ok' ? 'text-green-300' : 'text-red-300'}`} data-testid="change-password-msg">{msg.text}</p>
          )}
          <div className="md:col-span-3 flex items-center gap-3">
            <button type="submit" disabled={loading || !current || !next || !confirm} className="flex items-center gap-2 bg-[#d9fb06] text-[#1a1c1b] px-5 py-2 rounded-full font-bold hover:bg-[#c4e205] transition-colors disabled:opacity-50" data-testid="change-password-submit">
              {loading ? <Loader2 size={16} className="animate-spin" /> : <KeyRound size={16} />}
              Mettre à jour
            </button>
            <button type="button" onClick={onLogout} className="text-sm text-[#888680] hover:text-[#dfddd6] underline" data-testid="change-password-logout">Se déconnecter</button>
          </div>
        </form>
      )}
    </div>
  );
};

export default ChangePasswordAdmin;
